import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form/immutable';
import get from 'lodash/get';

import { Input } from 'shared/ui/Input';

// eslint-disable-next-line import/no-default-export
export default class FormAddressCore extends React.Component {
  state = {};

  UNSAFE_componentWillMount() {
    // @ts-expect-error
    const { name, hideNote } = this.props;
    const location = get(this.props, `entity.${name}`) || {};
    if (!hideNote) {
      this.setState({
        showAddressNotes: !!location.note,
      });
    }
  }

  render() {
    // @ts-expect-error
    const { showAddressNotes } = this.state;
    // @ts-expect-error
    const { showHeader = false, name, hideNote } = this.props;

    return (
      <div>
        {showHeader && <h4>{translate('Address')}</h4>}
        <div className="row">
          <div className="col-xs-6">
            <Field component={Input} name={`${name}.street`} label={translate('Street')} />
          </div>
          <div className="col-xs-6">
            <Field component={Input} name={`${name}.city`} label={translate('City')} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Field component={Input} name={`${name}.state`} label={translate('Country')} />
          </div>
          <div className="col-xs-6">
            <Field
              component={Input}
              name={`${name}.postalCode`}
              label={translate('Postal Code')}
              postfix={showAddressNotes || hideNote ? null : <i className="fa fa-sticky-note-o" />}
              postfixClass="with-button"
              postfixAddonClass="btn btn-default btn-sm"
              postfixOnClick={() =>
                this.setState({
                  showAddressNotes: true,
                })
              }
            />
          </div>
        </div>
        {showAddressNotes && !hideNote && (
          <div className="row">
            <div className="col-xs-12">
              <Field labelClass="hide" component={Input} name={`${name}.note`} placeholder="Add note" nullify />
            </div>
          </div>
        )}
      </div>
    );
  }
}

// @ts-expect-error
FormAddressCore.propTypes = {
  location: PropTypes.object,
  showHeader: PropTypes.bool,
  name: PropTypes.string.isRequired,
  hideNote: PropTypes.bool,
};
